/**
 *
 * Acequia Utils
 *
 *
 *
 */

import { createId, QRious, localforage, webdav } from '../deps.js'
import { debounced } from './debounced.js'
import { Evented } from './evented.js'
import { generateRandomName, generateRandomSlug } from './names.js'
import {
    redactSensitive,
    sanitizeRequestForLog,
    sanitizeResponseForLog,
    SENSITIVE_HEADER_RE,
} from './redact.js'

export { redactSensitive, sanitizeRequestForLog, sanitizeResponseForLog, SENSITIVE_HEADER_RE }

/**
 *
 * return the part of path that
 * after the matching part of an
 * application/acequia.js script
 *
 * @param {} context
 */
function getTrimmedPath(request) {
    return request?.aliasObj?.match || request?.scriptPath
}

/**
 * Detect the current JavaScript runtime context
 * @returns {'browser' | 'service-worker' | 'web-worker' | 'node' | 'deno' | 'unknown'}
 */
export function getContext() {
    // Deno - check before Node.js since Deno can have process polyfills
    if (typeof Deno !== 'undefined') {
        return 'deno'
    }

    // Node.js
    if (typeof process !== 'undefined' && process.versions?.node) {
        return 'node'
    }

    // Service Worker
    if (typeof ServiceWorkerGlobalScope !== 'undefined' &&
        self instanceof ServiceWorkerGlobalScope) {
        return 'service-worker'
    }

    // Web Worker (SharedWorker, DedicatedWorker)
    if (typeof WorkerGlobalScope !== 'undefined' &&
        self instanceof WorkerGlobalScope) {
        return 'web-worker'
    }

    // Browser main thread
    if (typeof window !== 'undefined') {
        return 'browser'
    }

    return 'unknown'
}

// Convenience helpers for context detection
export const isBrowser = () => getContext() === 'browser'
export const isServiceWorker = () => getContext() === 'service-worker'
export const isWebWorker = () => getContext() === 'web-worker'
export const isNode = () => getContext() === 'node'
export const isDeno = () => getContext() === 'deno'
export const isWorkerContext = () => ['service-worker', 'web-worker'].includes(getContext())

export default {
    createId,
    generateRandomName,
    generateRandomSlug,
    getTrimmedPath,
    localforage,
    debounced,
    Evented,
    QRious,
    webdav,
    getContext,
    isBrowser,
    isServiceWorker,
    isWebWorker,
    isNode,
    isDeno,
    isWorkerContext,
    redactSensitive,
    sanitizeRequestForLog,
    sanitizeResponseForLog,
}
